import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/apps/web/components/ui/breadcrumb";
import { cn } from "@/packages/utils/cn";

export interface BreadcrumbCrumb {
  label: string;
  to?: string;
}

interface TopbarProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  crumbs?: BreadcrumbCrumb[];
  className?: string;
}

export function Topbar({
  eyebrow,
  title,
  subtitle,
  actions,
  crumbs = [],
  className,
}: TopbarProps) {
  return (
    <div
      className={cn(
        "bg-paper border-b border-rule",
        className,
      )}
    >
      {(crumbs.length > 0 || eyebrow) && (
        <div className="px-4 sm:px-8 pt-3 flex items-center justify-between gap-3">
          <Breadcrumb>
            <BreadcrumbList className="text-xs sm:text-sm">
              {crumbs.map((c, i) => {
                const isLast = i === crumbs.length - 1;
                return (
                  <span key={i} className="contents">
                    <BreadcrumbItem>
                      {isLast || !c.to ? (
                        <BreadcrumbPage>{c.label}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink asChild>
                          <Link to={c.to}>{c.label}</Link>
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast && <BreadcrumbSeparator />}
                  </span>
                );
              })}
              {eyebrow && crumbs.length > 0 && <BreadcrumbSeparator />}
              {eyebrow && (
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-muted-foreground font-normal">
                    {eyebrow}
                  </BreadcrumbPage>
                </BreadcrumbItem>
              )}
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      )}
      <div className="px-4 sm:px-8 py-4 sm:py-5 flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <h1 className="font-sans font-semibold tracking-[-0.025em] text-2xl sm:text-3xl text-foreground leading-tight">
            {title}
          </h1>
          {subtitle && (
            <div className="mt-1.5 text-muted-foreground text-sm">
              {subtitle}
            </div>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-wrap">{actions}</div>
        )}
      </div>
    </div>
  );
}
